import { FC, useMemo } from 'react';
import { EntryResultEnum } from 'src/ts/enums';
import { OFFER_LETTER_TYPE } from '../helpers/proofHelpers';
import CustomDropdown from './CustomDropdown';

interface CustomResultDropdownProps {
  value: string;
  onChange: (value: string) => void;
  id?: string;
  documentType?: string;
}

export const RESULT_OPTIONS = [
  { value: EntryResultEnum.Clean, label: 'Clean', icon: '/assets/images/clean.png' },
  { value: EntryResultEnum.Edited, label: 'Edited', icon: '/assets/images/edited.png' },
  {
    value: EntryResultEnum.Undetermined,
    label: 'Insufficient',
    icon: '/assets/images/insufficient.png'
  }
];

export const resultLabel = (result?: string): string | undefined =>
  RESULT_OPTIONS.find((option) => option.value === result)?.label;

const CustomResultDropdown: FC<CustomResultDropdownProps> = ({
  value,
  onChange,
  id,
  documentType
}) => {
  const options = useMemo(
    () =>
      documentType === OFFER_LETTER_TYPE
        ? RESULT_OPTIONS.filter((opt) => opt.value !== EntryResultEnum.Clean)
        : RESULT_OPTIONS,
    [documentType]
  );

  return (
    <CustomDropdown
      id={id}
      value={value}
      onChange={onChange}
      options={options}
      placeholder="Result"
    />
  );
};

export default CustomResultDropdown;
